import { TemplateEntity } from '@entities/Template/Types';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import TemplatesCheckboxList from '@modules/Steps/Components/Step1/TemplateMeasurements/TemplatesCheckboxList/TemplatesCheckboxList';
import FragmentAndTemplateQuestionSection from '@modules/Steps/Components/Step1/TemplateMeasurements/FragmentAndTemplateQuestionSection/FragmentAndTemplateQuestionSection';
import styles from './TemplateMeasurements.module.css';
import { CustomProjectStep1ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep1ElementsIdsEnum';
import React from 'react';

interface Props {
    template?: TemplateEntity;
}

const TemplateMeasurements: React.FC<Props> = ({ template }) => {
    const [isDesktop, _isTablet, _isMobile] = useMediaType();

    return (
        <div className={styles.container}>
            {isDesktop && <TemplatesCheckboxList template={template} />}

            {template?.questions && template?.questions?.length > 0 && (
                <FragmentAndTemplateQuestionSection template={template} />
            )}

            {template?.fragments.map((fragment, i) => (
                <div
                    id={
                        i === 0
                            ? CustomProjectStep1ElementsIdsEnum.TEMPLATE_MEASUREMENTS_STEP1_SECTION
                            : undefined
                    }
                    key={i}
                >
                    {fragment.questions && fragment.questions.length > 0 && (
                        <FragmentAndTemplateQuestionSection
                            fragment={fragment}
                        />
                    )}
                </div>
            ))}
        </div>
    );
};

export default React.memo(TemplateMeasurements);
